import {
  ProductInstanceResult,
  AdminUserResult,
  INSTANCE_STATION,
  INSTANCE_COMPANY,
  INSTANCE_CLUSTER
} from "@futuri/cloudsso-client";
import { getInstanceHierarchyInstanceId } from "@futuri/cloudsso-client/src/instanceUtils";
import { notUndefined } from "@futuri/cloudsso-client/src/util";
import { AdminUserPostState } from ".";

// get boundInstances() {
export const boundInstances = async (
  _: AdminUserPostState,
  { rootGetters, getters }: { rootGetters: any; getters: any }
): Promise<ProductInstanceResult[]> => {
  const { availableInstances } = rootGetters;
  const { currentUser } = getters;

  // const currentUser = rootGetters["adminUserPost/currentUser"] as AdminUserResult

  // const allInstances = this.availableInstances ?? []
  // const availableInstances = this.availableInstances ?? [];

  // const instances = this.instances ?? [];

  const instances = availableInstances ?? [];
  const stations = new Set(currentUser?.postDetails?.stations ?? []);

  // Get stations accessible by the currently selected user
  const userInstances = instances.filter(
    (inst: { instanceType: string; name: unknown }) =>
      inst.instanceType === INSTANCE_STATION && stations.has(inst.name)
  );

  // Collect company and cluster for those stations only
  const companyInstanceIds = userInstances.map((inst: ProductInstanceResult) =>
    getInstanceHierarchyInstanceId(inst, INSTANCE_COMPANY)
  );
  const clusterInstanceIds = userInstances.map((inst: ProductInstanceResult) =>
    getInstanceHierarchyInstanceId(inst, INSTANCE_CLUSTER)
  );
  // const stationInstanceIds = userInstances?.filter(inst => inst.instanceType === INSTANCE_STATION ? inst.instanceId : undefined).filter(notUndefined)
  const stationInstanceIds = userInstances.map((inst: ProductInstanceResult) =>
    getInstanceHierarchyInstanceId(inst, INSTANCE_STATION)
  );
  const set = new Set(
    [
      ...companyInstanceIds,
      ...clusterInstanceIds,
      ...stationInstanceIds
    ].filter(notUndefined)
  );

  // Filter the original list (available to the logged in user) by those criteria
  const matching = instances?.filter((inst: { instanceId: any }) =>
    set.has(inst.instanceId)
  );
  return matching;
};
